<template>
  <svg
    style="height: 1em; height: 1em"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    stroke-width="4"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M6 10 24 4 42 10V20C42 31 35 41 24 45 13 41 6 31 6 20Z" />
    <path
      d="M17 19C17 15 20 12 24 12 28 12 31 15 31 18 31 20 30 23 27 24 25 25 24 26 24 27V29"
    />
    <circle cx="24" cy="36" r="2.4" fill="currentColor" stroke="none" />
  </svg>
</template>
